import BookingDiaryDayComponentHtml from './booking-diary.day.html';

export const BookingDiaryDayComponent : ng.IComponentOptions = {
  bindings: {
    event: '='
  },
  controller : 'BookingDiaryDayCtrl',
  templateUrl: BookingDiaryDayComponentHtml
};
